import * as React from 'react';
import { ImageProps } from 'components/Image';
import { TraceLogo } from 'components/Logo';

export const Logo: React.FC<ImageProps> = () => <TraceLogo sx={{ mb: 6 }} />;
